import Vue from 'vue'
import Router from 'vue-router'
const Register = () => import('@/components/LogReg/Register')
const Login = () => import('@/components/LogReg/Login')
const Home = () => import('@/pages/Home/Home')
const Courselist = () => import('@/pages/Courselist/Courselist')
const Coursedetail = () => import('@/pages/Coursedetail/Coursedetail')
const Personal = () => import('@/pages/Personal/Personal')
const Mystudy = () => import('@/pages/Mystudy/Mystudy')
const Search = () => import('@/pages/Search/Search')
const Player = () => import('@/pages/Player/Player')
const DPlayer = () => import('@/pages/Player/DPlayer')
const Pay = () => import('@/pages/Pay/Pay')
const Member = () => import('@/pages/Member/Member')
const Share = () => import('@/pages/Share/Share')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/courselist',
      name: 'Courselist',
      component: Courselist
    },
    {
      path: '/coursedetail',
      name: 'Coursedetail',
      component: Coursedetail
    },
    {
      path: '/share',
      name: 'Share',
      component: Share
    },
    {
      path: '/personal',
      name: 'personal',
      component: Personal
    },
    {
      path: '/mystudy',
      name: 'Mystudy',
      component: Mystudy
    },
    {
      path: '/search',
      name: 'Search',
      component: Search
    },
    {
      path: '/player',
      name: 'Player',
      component: Player
    },
    {
      path: '/dplayer',
      name: 'DPlayer',
      component: DPlayer
    },
    {
      path: '/pay',
      name: 'Pay',
      component: Pay
    },
    {
      path: '/member',
      name: 'Member',
      component: Member
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js